// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iLWg","field":"styles_field__176B7","fieldCol":"styles_fieldCol__33x_U","diffCol":"styles_diffCol__jyMHt","diff":"styles_diff__1AWkf"};